module.exports = __webpack_public_path__ + "static/media/BG_PDJ_HROD_Consulting.8222b338.jpg";